<div class="fleet-chat-toolbar">
  <label class="fleet-chat-filter">
    <input type="checkbox" [(ngModel)]="showDonations" />
    Show donations
  </label>
  <span class="fleet-chat-source-badge" *ngIf="usingStoredHistory" title="Showing long-range history from the companion's stored chat log">
    History
  </span>
  <span class="fleet-chat-source-badge fleet-chat-source-live" *ngIf="!usingStoredHistory && fleetMessages.length > 0" title="Showing the live PSS chat window (not logged)">
    Live
  </span>
</div>

<div class="tab-loading-container">
  <div class="tab-loading-overlay" *ngIf="fleetChatLoading && fleetMessages.length > 0">
    <div class="spinner-lg"></div>
  </div>
  <div class="tab-loading-area" *ngIf="fleetChatLoading && fleetMessages.length === 0">
    <div class="spinner-lg"></div>
    <span>Loading…</span>
  </div>

  <div class="fleet-chat-messages" #chatMessages *ngIf="!fleetChatLoading || fleetMessages.length > 0">
    <div class="fleet-chat-empty" *ngIf="filteredMessages.length === 0">No messages yet.</div>
    <div class="fleet-chat-msg" *ngFor="let msg of filteredMessages">
      <span class="chat-time">{{ formatChatTime(msg.dateTime) }}</span>
      <span class="chat-name">{{ msg.userName }}</span>
      <span class="chat-text">: {{ msg.message }}</span>
    </div>
  </div>
</div>

<div class="error-msg" *ngIf="fleetChatError">{{ fleetChatError }}</div>

<div class="fleet-chat-input-row">
  <input class="fleet-chat-input" type="text" [(ngModel)]="fleetChatInput"
         (keydown.enter)="sendFleetChat()" placeholder="Chat message…"
         maxlength="256"
         [disabled]="fleetChatSending || restrictedMode" />
  <button class="btn btn-primary btn-sm" (click)="sendFleetChat()"
          [disabled]="!fleetChatInput.trim() || fleetChatSending || restrictedMode"
          [title]="restrictedMode ? 'Fleet chat is disabled in restricted mode' : ''">Send</button>
  <button class="btn btn-ghost btn-sm" title="Refresh" (click)="loadFleetMessages()">↻</button>
</div>
